import apiClient from './api.service';
import {
  ParticipationIntent,
  PublicSurveyPageData,
  PublicSurveyStatus,
} from '../types/publicSurvey.types';
import { PUBLIC_SURVEY_PAGE_SIZE } from '../config/publicSurvey.config';

class PublicSurveyService {
  async list(status: PublicSurveyStatus, page: number = 1, tagIds: string[] = []): Promise<PublicSurveyPageData> {
    const response = await apiClient.get<{ data: PublicSurveyPageData }>('/api/public/surveys', {
      params: {
        status,
        page,
        pageSize: PUBLIC_SURVEY_PAGE_SIZE,
        tagIds: tagIds.length > 0 ? tagIds.join(',') : undefined,
      },
    });

    return response.data.data;
  }

  async listFilterTags(): Promise<Array<{ id: string; name: string }>> {
    const response = await apiClient.get<{ data: { items: Array<{ id: string; name: string }> } }>(
      '/api/public/surveys/tags',
    );

    return response.data.data.items;
  }

  async getTrailUrl(surveyId: string): Promise<string> {
    const response = await apiClient.get<{ data: { surveyId: string; trailUrl: string } }>(
      `/api/public/surveys/${surveyId}/trail`
    );

    return response.data.data.trailUrl;
  }

  async startParticipationIntent(surveyId: string): Promise<ParticipationIntent> {
    const response = await apiClient.post<{ data: ParticipationIntent }>(
      `/api/surveys/${surveyId}/participation-intent`
    );

    return response.data.data;
  }
}

export const publicSurveyService = new PublicSurveyService();
